module.exports = __webpack_public_path__ + "media/images/illustrations/scale-52b86dd45e2ea038e472c4cb15a599a4.svg";